"use strict";

import Vue from 'vue';
import axios from "axios";
import myfun from "../../public/myfun.js"

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
	timeout: 60 * 1000, // Timeout
	headers:{
		'Content-Type':'application/json;charset=utf-8'
	}
  // withCredentials: true, // Check cross-site Access-Control
};

let token = null

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
	if(!token){
		let t = sessionStorage.getItem("token")
		if(t){
			token=t
		}
	}
	if(token){
		config.headers.Token=token
	}
	const arr = config.url.split(":")
	switch (arr[0]) {
		case "data":
		config.url="http://47.109.80.27:7000/"+arr[1]//47.109.80.27
		break
		case "test":
		config.url="http://47.109.80.27:7070/"+arr[1]
		break
	}
    return config;
  },
  function(error) {
    // Do something with request error
    myfun.messageErrClose(error);
	myfun.Loadingclose()
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
	if(response.status===200){
		token=response.headers.token
		if(token){
			sessionStorage.setItem("token",token)
		}
		if(response.data.ok){
			return response.data.data;
		}
		myfun.messageErrClose(response.data.err)
	}
	myfun.Loadingclose()
  },
  function(error) {
    // Do something with response error
    myfun.messageErrClose(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default _axios;
